export const appPaths = {
  HOME: '',
  WHATSYOURTD1RISK: 'know-your-risk',
  WHATIST1D: 'stages-of-type-1-diabetes',
  COSTSNOTKNOWKING: 'why-screen-for-t1d',
  BENEFITSOFKNOWING: 'benefits-of-knowing',
  FAMILYHISTORY: 'the-family-factor-t1d-survey',
  MAKEAPLEDGE: 'make-a-pledge',
  REQUESTSCREENING: 'request-a-t1d-screening',
  HOWTOSCREEN: 'about-t1d-screening',
  USEFULTOOLS: 'action-plan',
  SIGNUP: 'get-updates',
  THANKYOU: 'thank-you',
  THANKYOU1: 'thank-you-1',
  THANKYOU2: 'thank-you-2',
  THANKYOU3: 'thank-you-3',
  THANKYOU4: 'thank-you-4',
  SPANISH: 'es',
  NOTFOUND: '404',
  SITEMAP: 'site-map',
  UNKNOWN: '**',
  EARLYDETECTION: 'hcp/early-detection-of-t1d',
  T1DFAMILYHISTORY: 'hcp/t1d-family-history',
  RESOURCE: 'hcp/t1d-screening-resources',
};
